<template>
  <div class="df" style="height: 300px">
    <div class="card-dashboard-wings__chart">
      <slot></slot>
    </div>
    <div v-if="data" class="card-dashboard-wings__legend">
      <div v-for="(item,index) in data" :key="index">
        <i v-if="item.itemStyle" :style="{'color':item.itemStyle.color}" class="md-icon md-small">circle</i>
        <i v-else :style="{'color':useColors[index]}" class="md-icon md-small">circle</i>
        <span>
          <slot name="legend"
                v-bind:legend="item"
                v-bind:percent="percent(item)">
            {{item.name}}
          </slot>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "chartCardDashboardWings",
  props: {
    noFooter: Boolean,
    data: Array,
  },
  data() {
    return {
      colors:[],
      colors2:['#37a2da','#fdd85c'],
      colors5:['#37a2da','#67e0e3','#fdd85c','#fc9f7f','#e062ae'],
      colors8:['#37a2da','#32c5e9','#9fe6b8','#fddb5c','#fc9f7f','#fb7193','#e7bcf3','#8278ea'],
      colorsNew:['#37a2da','#32c5e9','#67e0e3','#9fe6b8','#fddb5c','#fc9f7f','#fb7193','#e062ae',"#e690d1",'#e7bcf3','#9d96f5','#8278ea','#95bfff'],
    };
  },
  computed: {
    useColors(){
      if (this.data.length <= 2) return this.colors2;
      if (this.data.length <= 5) return this.colors5;
      if (this.data.length <= 8) return this.colors8;
      return this.colorsNew
    }
  },
  methods: {
    percent(item){
      let total = 0;
      this.data.forEach(row => {
        total+= row.value
      });
      return (item.value / total * 100).toFixed(2)
    }
  },
  mounted() {}
};
</script>

<style>
.card-dashboard-wings__legend {
  flex: 1 1 40%;
  min-width: 40%;
  flex-shrink: 0;
  align-self: center;
  text-align: left;
}
.md-icon.md-small {
  font-size: 14px !important;
}
</style>
